import { Container } from "./Container";
import floppy from "../images/backgrounds/floppy.jpg";

const faqs = [
  [
    {
      question: "Where can I buy the book?",
      answer: `We are currently at the crowdsourcing stage. You can secure your future copy by backing SEWER SCUM on Kickstarter.`,
    },
    {
      question: "Is the book finished?",
      answer:
        "At the time of the Kickstarter launch, the book is 100% complete and thoroughly playtested.",
    },
    {
      question: "Will there be supplements?",
      answer:
        "This website has free printable character sheets and an online character generator. There are also plans to release free adventures on this website and social channels in the future. There are rough plans for a future supplement with added content, a timeline is dependent on the success of this project.",
    },
  ],
  [
    {
      question: "Is it compatible with Mork Borg or Cy_Borg?",
      answer:
        "Both! Since a core concept of the setting is gonzo chaos from mutations, alien technology, and extra dimensional portals, it’s easy to mash up any genre’s content into SEWER SCUM.",
    },
    {
      question: "Can I release third party content?",
      answer:
        "Absolutely! Check out the Third party license in the Content section. Also, if you want to send us a copy we’d love to play your content too!",
    },

    {
      question: "Do you sell to game stores?",
      answer:
        "Yes! For now, there is a merchant tier on the Kickstarter. If you're a physical or online retailer, please don't hesitate to reach out if you have more questions.",
    },
  ],
  [
    {
      question: "What are SEWER SCUM’s inspirations?",
      answer:
        "'80s action movies, '80s and early '90s zines. Teenage Mutant Ninja Turtles. Frank Miller’s Batman and Daredevil. Saturday Morning Cartoons. OSR Blogs and other Borgs.",
    },
    {
      question: "Where can it be shipped?",
      answer:
        "Most locations on planet Earth. There are a few countries where shipping is tricky (more details on the Kickstarter), and extra dimensiontal shipping is prohibitively expensive.",
    },
    {
      question: "Will I get sick if I eat these pizzas?",
      answer:
        "Deadly sick? Probably not. Gagging sick? Definitely a possibility. If you make a pizza you rolled from the table, send us a pic!",
    },
  ],
];

export function Faqs() {
  return (
    <section
      id="faqs"
      aria-labelledby="faqs-title"
      className="py-0"
    >
      <div
        className="relative overflow-hidden py-20 sm:py-32 lg:pb-32 xl:pb-36"
        style={{
          backgroundImage: `url(${floppy})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "#000000",
        }}
      >
        <Container>
          <div className="mx-auto max-w-2xl lg:mx-0 bg-black p-4 rounded-2xl">
            <h2
              id="faqs-title"
              className="text-3xl font-medium tracking-tight text-[#00FF00] pixeloid-sans"
            >
              Frequently asked questions
            </h2>
            <p className="mt-2 text-lg text-white">
              If you have anything else you want to ask,{" "}
              <a
                href="mailto:dicecatscontact@gmail.com"
                className="underline"
              >
                reach out to us
              </a>
              .
            </p>
          </div>
          <ul
            role="list"
            className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 sm:mt-20 lg:max-w-none lg:grid-cols-3"
          >
            {faqs.map((column, columnIndex) => (
              <li key={columnIndex}>
                <ul role="list" className="space-y-10 ">
                  {column.map((faq, faqIndex) => (
                    <li key={faqIndex} className="bg-black text-[#00FF00] p-4 rounded-2xl">
                      <h3 className="text-lg font-semibold leading-6 pixeloid-sans">
                        {faq.question}
                      </h3>
                      <p className="mt-4 text-sm text-white">{faq.answer}</p>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </Container>
      </div>
    </section>
  );
}
